import React, { useState, useEffect, useRef } from 'react';
import { Card, Justify, PagingQuery } from 'tea-component';
import Visualis from '@/pages/intelligence/pages/Potential/components/Visualis/NewReleaseVisualis';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import NewReleaseGamesTable from '@/pages/intelligence/pages/Potential/components/Tables/NewReleaseGamesTable';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import ExportTable from '../../../../components/ExportTable';
import { useIntl, getLocale, useSelector, history } from 'umi';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import useNewReleaseModel, { FetchParamsType } from '../../hooks/useNewReleaseModel';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  fetchTopChartsMobileNR,
  fetchTopChartsPCConsoleNR,
} from '@/pages/intelligence/services/topcharts';
import Loading from '@/pages/intelligence/components/Loading';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import useNewReleaseBarCharts from '@/pages/intelligence/pages/Potential/hooks/useNewReleaseBarCharts';
import useNewReleaseLineCharts from '@/pages/intelligence/pages/Potential/hooks/useNewReleaseLineCharts';
import ChartIconType from '@/pages/intelligence/components/ChartsComponents/ChartIconType';
import { getFilterName, getFilterValueStorage } from '@/pages/intelligence/components/Filter/util';

import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import { tranFormSenorTowerTagParam } from '@/pages/intelligence/utils/topchartsUtils';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import { stripFetchParamsFilter } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import {
  SEGMENT_CHART_SOURCE,
  SEGMENT_CHART_ICONMETRICS,
} from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { getValidTopSelectGame } from '@intelligence/utils/topchartsUtils';
import {
  updateShortLinkPath,
  // ShortLinkQueryType,
  URL_SHORT_LINK_NAME,
  URL_CHART_METRIC,
  URL_SORT_NAME,
  URL_CHART_TYPE,
  URL_ORDER,
  URL_RATIO_TYPE,
} from '@intelligence/utils/urlPathCfg';
import { potential } from '@intelligence/v3/constants/downloadLogPoint';
import { buildTopChartsTagClickHandler } from '@intelligence/v3/utils/sensorTowerTagColumns';
import useMobileTopChartsTagDetails from '@intelligence/v3/pages/TopCharts/MobileGames/_hooks/useMobileTopChartsTagDetails';
// import {
//   START_RELEASE_TIME,
//   END_RELEASE_TIME,
// } from '@/pages/intelligence/components/Filter/FilterBase/_config';

const NEWRELEASE = 'newrelease';

interface NewReleaseProps {
  entityType: string;
  pageLogInfo: any;
  downloadFileName: string;
  filterLoading: boolean;
  filterCfg: any;
  shortLinkValidQuery?: any;
  shortLinkFilterValue?: any;
  urlCustomParams?: any;
  topchartsNameParams?: any;
  stickyHeaderTitle?: React.ReactNode;
  pageId?: string;
}
export default function NewRelease(props: NewReleaseProps) {
  const {
    entityType,
    pageLogInfo,
    downloadFileName,
    filterLoading,
    filterCfg,
    shortLinkValidQuery,
    shortLinkFilterValue,
    urlCustomParams,
    stickyHeaderTitle,
    pageId,
    // topchartsNameParams,
  } = props;

  const [tableLoading, setTableLoading] = useState(true);
  const [isVisualisLoading, setIsVisualisLoading] = useState(true);
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });

  const segmentChartList = SEGMENT_CHART_SOURCE[entityType + NEWRELEASE];
  const segmentChartIconList = SEGMENT_CHART_ICONMETRICS[entityType + NEWRELEASE];

  const isHasSegmentChart = !!(segmentChartList && Array.isArray(segmentChartList));
  const isHasSegmentChartIcon = !!(segmentChartIconList && Array.isArray(segmentChartIconList));

  const segmentListDatas = isHasSegmentChart
    ? segmentChartList
    : isHasSegmentChartIcon
    ? segmentChartIconList
    : [];

  const { query } = history.location || {};

  // 在筛选器这里拿到缓存的值，并渲染
  const filterSaveName = getFilterName(userInfo);
  const filterSaveData = getFilterValueStorage(userInfo);
  // NewRelease 是 Mobile TopCharts 的独立 tab，不能复用 Potential/其他榜单的 common 继承值。
  const { filterExtend, setFilterExtend, isOperate } = useFilterExtend({ pageId });
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;
  const [filterValue, setFilterVale] = useState(isOperate ? filterExtend : DEFAULT_FORM_VALUE);
  const filterRef = useRef<any>(null);

  // 是否重新操作过复选器提交
  const [isNewComfirm, setIsNewComfirm] = useState(true);
  // 是否重新勾选过游戏
  const [isNewCheckGame, setIsNewCheckGame] = useState(true);
  // echarts图表类型
  const [chartType, setChartType] = useState<ChartType>(ChartType.Bar); // 当前排序指标名
  const [segmention, setSegmention] = useState(
    segmentListDatas?.length > 0 ? segmentListDatas[0].value : 'Metrics',
  );
  const [sortByName, setSortByName] = useState(
    entityType == 'console'
      ? 'dbi_release_date'
      : segmentListDatas?.length > 0
      ? segmentListDatas[0].text
      : 'dbi_new_release',
  );
  const [titleNow, setTitleNow] = useState(
    segmentListDatas?.length > 0 ? segmentListDatas[0].text : 'dbi_new_release',
  );
  const {
    tableData,
    tableTotal,
    barOrPieData,
    setBarOrPieData,
    lineData,
    fetchParams,
    getGameData,
    getLineChartData,
    tableSelection,
    defaultSelectionGames,
    orderMetricCur,
    operatedGame,
    setOperatedGame,
    isNodata,
    setTableSelection,
    handleClearSearch,
    transTableDataForSearch,
  } = useNewReleaseModel({
    entityType,
    chartType,
    setChartType,
    shortLinkValidQuery,
    filterValue,
    setFilterVale,
    hasUrlShortLink: filterCfg?.hasUrlShortLink,
    defaultSelectGameNum: getValidTopSelectGame(query?.topSelect),
  });

  const { gameDetailsLoading, gameDetailsMapping } = useMobileTopChartsTagDetails(
    tableData,
    { enabled: entityType === 'mobile' },
  );

  const getData = (args: {
    params: FetchParamsType;
    isCheckGame: boolean;
    isSearch?: boolean;
    isUpdateLineChart?: boolean;
    updateFilterValues?: any;
    myFilterValue?: string;
  }) => {
    const {
      params,
      isCheckGame,
      isSearch = false,
      isUpdateLineChart = false,
      updateFilterValues = filterValue,
      myFilterValue = filterSaveName,
    } = args;

    getGameData({
      params: { ...params, game_code: isSearch ? params?.game_code : [] },
      isCheckOrSearch: isCheckGame,
      isUpdateLineChart,
      updateFilterValues,
      filterSaveName: myFilterValue,
    })
      .then(() => {
        setTableLoading(false);
        setIsVisualisLoading(false);
        setIsNewComfirm(true);
      })
      .catch(() => {
        setTableLoading(false);
        setIsVisualisLoading(false);
      });
  };

  const getTrend = (params: FetchParamsType, selectionList: TableSelectionType[]) => {
    setIsVisualisLoading(true);
    const idList = selectionList.map((t) => t?.gameId);
    getLineChartData({ ...params, game_code: idList || [] })
      .then(() => {
        setIsVisualisLoading(false);
        setIsNewComfirm(false);
        setIsNewCheckGame(false);
      })
      .catch(() => {
        setIsVisualisLoading(false);
      });
  };

  useEffect(() => {
    setTableLoading(true);
    setIsVisualisLoading(true);
    if (!userInfo?.userid || filterLoading) {
      // 拿缓存值需要拿到用户id
      return;
    }
    let newFetchParams = { ...fetchParams };

    const hasUrlShortLinkVal = query?.[URL_SHORT_LINK_NAME];

    const { filterValue: newFilterValues, filterParams } = getDbiFilterParams({
      userInfo,
      urlCustomParams,
      urlShortLinkFilter: shortLinkFilterValue,
      filterSaveData: filterSaveData?.apiValue,
      filterExtend,
      specialParams: filterCfg?.specialParams,
      isOperate,
      filterName: filterSaveName,
      filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
    });

    // 如果有短链接，设置为继承模式
    if (isOperate || hasUrlShortLinkVal) {
      // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
      setFilterExtend(newFilterValues);
    }
    setFilterVale(newFilterValues);
    newFetchParams = {
      ...stripFetchParamsFilter(newFetchParams),
      ...(urlCustomParams || {}),
      ...filterCfg?.handleFilterToApiParams?.(filterParams),
    };

    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: newFilterValues,
    });
  }, [userInfo?.userid, filterLoading, shortLinkFilterValue]);

  // 柱状图相关hooks
  const { seriesData: barSeriesData, barNameList } = useNewReleaseBarCharts(
    barOrPieData,
    segmention,
  );

  useEffect(() => {
    if (shortLinkValidQuery) {
      if (shortLinkValidQuery[URL_CHART_TYPE] !== undefined) {
        setChartType(shortLinkValidQuery?.[URL_CHART_TYPE]);
      }
      if (shortLinkValidQuery[URL_CHART_METRIC] !== undefined) {
        setSegmention(shortLinkValidQuery[URL_CHART_METRIC]);
      }
      if (shortLinkValidQuery[URL_SORT_NAME] !== undefined) {
        // 从URL获取的是value，需要找到对应的多语言key
        const sortNameValue = shortLinkValidQuery[URL_SORT_NAME];
        const matchedItem = segmentListDatas?.find((item: any) => item.value === sortNameValue);
        setSortByName(matchedItem?.text || sortNameValue);
      }
    }
  }, [shortLinkValidQuery]);

  useEffect(() => {
    if (!filterLoading && filterCfg?.hasUrlShortLink) {
      let shortObj = {
        [URL_SORT_NAME]: fetchParams.order_metric,
        [URL_ORDER]: fetchParams.order,
        [URL_CHART_METRIC]: segmention,
        [URL_RATIO_TYPE]: fetchParams.ratio_type,
      } as any;
      if (entityType === 'pc') {
        shortObj = {
          ...shortObj,
          [URL_CHART_TYPE]: chartType,
        };
      }
      // TODO找到它对应的文本， 修改它的名字
      updateShortLinkPath({
        shortLinkQuery: shortObj,
      });
    }
  }, [
    filterLoading,
    segmention,
    chartType,
    fetchParams.ratio_type,
    fetchParams.order_metric,
    fetchParams.order_source,
    fetchParams.order,
  ]);

  const {
    seriesData,
    xAxisData,
    yAxisFormatter,
    // tooltipFormatter,
    createLegendsCustomMade,
    // setSegment,
  } = useNewReleaseLineCharts({
    dateType: fetchParams.date_type,
    data: lineData,
    tableSelection,
  });

  const onTableSortChage = (e: SortByItemType) => {
    const newFetchParams: FetchParamsType = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.sortMetric || orderMetricCur,
      ratio_type: e?.ratioType || 0,
      page: 1,
      // page_size: 100,
      page_size: 50,
    };
    setTableLoading(true);
    if (!operatedGame) {
      /** 没有勾选时点排序则重新Loading柱状图数据 */
      setIsVisualisLoading(true);
    }
    setSortByName(e.title);
    setSegmention(newFetchParams?.order_metric);
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: !operatedGame,
    });
  };

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams: FetchParamsType = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      // page_size: e?.pageSize || 100,
      page_size: e?.pageSize || 50,
    };
    setTableLoading(true);
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: false,
    });
  };

  // 表格列表项选择事件回调
  const onTableCheckGame = (
    selectList: TableSelectionType[],
    checkStatus: TableSelectStatusType,
  ) => {
    setIsNewComfirm(true);
    setIsNewCheckGame(true);

    if (chartType === ChartType.Line) {
      getTrend(fetchParams, selectList);
    }
    /** 是否勾选了游戏 */
    if (checkStatus === 'cancel' || checkStatus === 'all' || selectList.length === 0) {
      setOperatedGame(false);
    } else {
      setOperatedGame(true);
      /** 处理游戏继承 */
      // TODO
    }
    /** 将表格数据转换为柱状或饼 */
    setBarOrPieData(selectList);
    setTableSelection(selectList);
  };

  // 切换charts类型事件
  const handleChartType = (value: ChartType) => {
    if (value === ChartType.Line && tableSelection?.length && isNewComfirm && isNewCheckGame) {
      getTrend(fetchParams, tableSelection);
    }
    setChartType(value);
  };

  const handleConfirm = (value: any, filter, myFilterValue) => {
    // 保存的方案选择后可特殊处理国家值为交集之后的值
    // const result = formatRegionParams(value?.markets);
    const newFormValue = {
      ...stripFetchParamsFilter(fetchParams),
      ...value,
      page: 1,
      // page_size: 100,
      page_size: 50,
      // markets: result,
    };
    // 请求接口
    setTableLoading(true);
    setIsVisualisLoading(true);
    getData({
      params: newFormValue,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: filter,
      myFilterValue,
    });

    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    setIsNewComfirm(true);
    setIsNewCheckGame(true);
  };

  const getTableSearchList = (id: string) => {
    setTableLoading(true);
    getData({
      params: { ...fetchParams, game_code: [id] },
      isCheckGame: true,
      isSearch: true,
      isUpdateLineChart: false,
    });
  };

  const handleReset = () => {};

  const handleTagClick = buildTopChartsTagClickHandler({
    filterRef,
    filterValue,
    setFilterValue: setFilterVale,
    sensorTowerTagConfig: filterCfg?.specialParams?.sensorTowerTagConfig,
  });

  return (
    <div className={entityType === 'mobile' ? 'dbi-potential-newrelease-page' : ''}>
      <Card>
        <Card.Body>
          <Filter
            ref={filterRef}
            filterConfirm={handleConfirm}
            filterReset={handleReset}
            extendPageId={pageId}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            defaultValue={DEFAULT_FORM_VALUE}
            filterCfg={{ ...filterCfg, stickyHeaderTitle }}
            buriedPointParams={pageLogInfo}
          />
        </Card.Body>
      </Card>
      <Card className="dbi-mobileGames-card-context">
        <Card.Body
          title={
            <div style={{ display: 'flex' }}>
              <span style={{ marginRight: 10 }}>{formatMessage({ id: 'dbi_new_release' })}</span>
              <ArrowdownText
                isNew={true}
                sortedData={formatMessage({ id: sortByName })}
                order={fetchParams.order}
              />
            </div>
          }
          operation={
            entityType == 'pc' && segmention == 'source_steam__pcu' ? (
              <ChartIconType chartType={chartType} handleChartType={handleChartType} />
            ) : null
          }
        >
          {isVisualisLoading ? (
            // 434-76
            <div style={{ height: entityType === 'pc' ? 374 : 358 }}>
              <Loading />
            </div>
          ) : (
            <Visualis
              fetchParams={fetchParams}
              chartType={chartType}
              setChartType={setChartType}
              barOrPieData={barOrPieData}
              barSeriesData={barSeriesData}
              barNameList={barNameList}
              imageType={entityType}
              topChartsType={NEWRELEASE}
              setSegmention={setSegmention}
              segmention={segmention}
              lineData={lineData}
              isNodata={isNodata}
              seriesData={seriesData}
              xAxisData={xAxisData}
              yAxisFormatter={yAxisFormatter}
              // tooltipFormatter={tooltipFormatter}
              createLegendsCustomMade={createLegendsCustomMade}
              isVisualisLoading={isVisualisLoading}
              // setSegment={setSegment}
              tableSelection={tableSelection}
              titleNow={formatMessage({ id: titleNow })}
              setTitleNow={setTitleNow}
              sortByName={formatMessage({ id: sortByName })}
              isHasSegmentChart={isHasSegmentChart}
              isHasSegmentChartIcon={isHasSegmentChartIcon}
              segmentListDatas={segmentListDatas}
            />
          )}
        </Card.Body>
      </Card>
      <Justify
        className="dbi-card-justify"
        right={
          <>
            <SearchRecent
              fetchParams={
                entityType === 'mobile'
                  ? tranFormSenorTowerTagParam({ ...fetchParams, page: 1, filter_ids: [] })
                  : { ...fetchParams, page: 1, filter_ids: [] }
              }
              handleClear={handleClearSearch}
              getTableResultList={getTableSearchList}
              searchListApi={
                entityType === 'mobile' ? fetchTopChartsMobileNR : fetchTopChartsPCConsoleNR
              }
              pageLogInfo={pageLogInfo}
              searchType={`${entityType}_newrelease`}
              transTableDataForSearch={transTableDataForSearch}
              initSearchInput={!(fetchParams?.game_code?.length > 0)}
            />
            <ExportTable
              entityType={entityType}
              businessType={`${entityType}-newRelease`}
              classModalName="dbi-download-type-one"
              isDisableDownload={tableLoading}
              tableParams={{ ...fetchParams, select_ids: tableSelection }}
              isNeedCheckedLines={true}
              defaultCheckedLines={operatedGame}
              isGameTopCharts={true}
              downloadModalSize={locale === LANGUAGE_CN ? 542 : 650}
              total={tableTotal}
              newStyleFileName={downloadFileName}
              downloadLogConfigKey={potential?.[`${entityType}_newRelease`]}
            />
          </>
        }
      />
      <CardSlot>
        <NewReleaseGamesTable
          entityType={entityType}
          records={tableData}
          loading={tableLoading}
          tableTotal={tableTotal}
          pageSortAttr={{
            tablePageIndex: fetchParams.page,
            tablePageSize: fetchParams.page_size,
            currentSortValue: fetchParams.order,
            currentSortMetric: `${fetchParams.order_metric}_${fetchParams.ratio_type}`,
          }}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          onTableCheckGame={onTableCheckGame}
          tableSelection={tableSelection}
          tableSelectionAll={defaultSelectionGames}
          filterValue={filterValue}
          gameDetailsLoading={gameDetailsLoading}
          gameDetailsMapping={gameDetailsMapping}
          onTagClick={handleTagClick}
        />
      </CardSlot>
    </div>
  );
}
